import { NotesTab as SharedNotesTab } from '@pmp/components';
import { TabProps } from '../interfaces';

export const NotesTab: React.FC<TabProps> = ({ form, entityType }) => (
  <SharedNotesTab form={form} entityType={entityType} entityIdField="id" />
);
